(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-article-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const hero = document.querySelector(
      '.content-for-layout > .recipe-article-hero-section.shopify-section:first-child .recipe-article-hero'
    );
    const headerGroup = document.querySelector('#header-group');
    if (!hero || !headerGroup) return;

    const getFloatingHeaderHeight = () => {
      const bar =
        headerGroup.querySelector('.iZzxFWWoPM8udDGd2') ||
        headerGroup.querySelector('#header-component') ||
        headerGroup.querySelector('header-component');

      if (bar) {
        const { position } = getComputedStyle(bar);
        if (position === 'fixed' || position === 'absolute') {
          return bar.getBoundingClientRect().height;
        }
      }

      const themeHeader = headerGroup.querySelector('.header[transparent], header-component[transparent]');
      return themeHeader?.offsetHeight ?? 0;
    };

    const syncHeaderOffset = () => {
      hero.style.setProperty('--rah-header-offset', `${getFloatingHeaderHeight()}px`);
    };

    syncHeaderOffset();
    if ('ResizeObserver' in window) {
      new ResizeObserver(syncHeaderOffset).observe(headerGroup);
    } else {
      window.addEventListener('resize', syncHeaderOffset);
    }
  })();

  document.addEventListener('click', async (event) => {
    const shareBtn = event.target.closest('[data-rah-share]');
    if (!shareBtn) return;

    const root = shareBtn.closest('.recipe-article-hero');
    if (!root) return;

    const statusEl = root.querySelector('[data-rah-share-status]');
    const title = root.dataset.rahShareTitle || document.title;
    const copiedMsg = root.dataset.rahLinkCopied || 'Link copied';

    try {
      if (navigator.share) {
        await navigator.share({ title, url: window.location.href });
      } else {
        await navigator.clipboard.writeText(window.location.href);
        if (statusEl) {
          statusEl.textContent = copiedMsg;
          setTimeout(() => { statusEl.textContent = ''; }, 3000);
        }
      }
    } catch (_) {}
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-rah-print]')) window.print();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-blog-grid-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-rbgf-drawer-open]');
    if (openBtn) {
      const root = openBtn.closest('.recipe-blog-grid-filter');
      const drawer = root?.querySelector('[data-rbgf-drawer]');
      if (!drawer) return;
      drawer.hidden = false;
      drawer.setAttribute('data-open', 'true');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      return;
    }

    const closeTarget = event.target.closest('[data-rbgf-drawer-close], [data-rbgf-drawer-backdrop]');
    if (closeTarget) {
      const drawer = closeTarget.closest('[data-rbgf-drawer]');
      if (!drawer) return;
      drawer.hidden = true;
      drawer.removeAttribute('data-open');
      const root = drawer.closest('.recipe-blog-grid-filter');
      const openBtn = root?.querySelector('[data-rbgf-drawer-open]');
      openBtn?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-rbgf-select]');
    if (select?.value) window.location.href = select.value;
  });

  } catch(e) { console.error(e); }
})();
})();
